import { InPageAlert } from '@snsw/react-component-library';
import { getVariant } from 'components/Question/components/getVariant';
import { QuestionConditionalMessage, ResponseValueType } from 'components/Question/types';
import { HelpMessage } from 'components/UserFeedback';

export const ConditionalMessages = <TValue extends ResponseValueType = boolean>({
  value,
  messages,
}: {
  value?: TValue[] | TValue;
  messages?: QuestionConditionalMessage<TValue>[];
}) => {
  if (!messages?.length) return null;

  return (
    <>
      {messages.map((c, index) => (
        <InPageAlert id={c.id} key={c.id ?? index} variant={getVariant(c.level)} title={c.title} role="alert">
          <HelpMessage>{typeof c.helpMessage === 'function' ? c.helpMessage(value) : c.helpMessage}</HelpMessage>
        </InPageAlert>
      ))}
    </>
  );
};
